import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { gameProductsListingThunk, purchasedGamesThunk } from './gamesThunk'

// Initial state
const initialState = {
	gamesData: [],
	totalItems: 0,
	currentPage: 1,
	itemsPerPage: 10,
	purchasedgamesData: [],
}

// Thunk to fetch games data
export const getGames = createAsyncThunk('user/getGames', gameProductsListingThunk)
export const purchasedGames = createAsyncThunk('user/purchasedGames', purchasedGamesThunk)

// Games slice
const gamesSlice = createSlice({
	name: 'games',
	initialState,
	reducers: {
		setCurrentPage: (state, action) => {
			state.currentPage = action.payload
		},
		setItemsPerPage: (state, action) => {
			state.itemsPerPage = action.payload
		},
	},
	extraReducers: (builder) => {
		builder.addCase(getGames.fulfilled, (state, action) => {
			state.gamesData = action.payload.data?.data
			state.totalItems = action.payload.total
		})
		builder.addCase(purchasedGames.fulfilled, (state, action) => {
			state.purchasedgamesData = action.payload.data?.data
		})
	},
})

export const { setCurrentPage, setItemsPerPage } = gamesSlice.actions

export default gamesSlice.reducer
